import React, { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { SCREEN_MAX_WIDTH } from '../stateProvider/StateProvider';
import { useLocation } from 'react-router-dom';

const PaddedWrapper = styled.div`
    padding: 1em;
    background: ${({ theme }) => theme.background};
    box-shadow: 0px 3px 10px ${({ theme }) => theme.shadow};
    transition: all 0.2s;
    height: calc(100svh - 8em);
    border-radius: 1rem;
    overflow: auto;
    overflow-x: hidden;

    scrollbar-gutter: stable;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        max-width: calc(100svw);
        scrollbar-gutter: unset;
    }
`
const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: ${({ theme }) => theme.text};
    position: relative;
    height: inherit;
`
const ShadowWrapper = styled.div`
    position: absolute;
    width: calc(100svw - 8em);
    height: calc(100svh - 6em);
    pointer-events: none;
`
const scrollShadow = styled.div`
    position: absolute;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 35px;
    pointer-events: none;
    transition: all 0.3s;
`
const ShadowTop = styled(scrollShadow)`
    top: 4em;
    background-image: radial-gradient(farthest-side at 50% 0%, ${({ theme }) => theme.shadow} 0%, rgba(0, 0, 0, 0) 100%);
    opacity: 0;
`
const ShadowBottom = styled(scrollShadow)`
    bottom: 0;
    background-image: radial-gradient(farthest-side at 50% 100%, ${({ theme }) => theme.shadow} 0%, rgba(0, 0, 0, 0) 100%);
    opacity: 0;
`


const Content = ({ children, ...props }) => {

    const bodyRef = useRef();
    const topRef = useRef();
    const botRef = useRef();
    const [shadowHeight] = useState(25)

    const location = useLocation();


    useLayoutEffect(() => {
        bodyRef.current.scrollTo(0, 0);
        adjustShadow();
    }, [location.pathname, location.hash]);

    const adjustShadow = () => {
        const body = bodyRef.current;
        const topShadow = topRef.current;
        const botShadow = botRef.current;

        const contentScrollHeight = body.scrollHeight - body.clientHeight;
        const currentScroll = body.scrollTop / contentScrollHeight;

        if (!isNaN(currentScroll)) {
            topShadow.style.opacity = currentScroll;
            botShadow.style.opacity = 1 - currentScroll;
            topShadow.style.height = currentScroll * shadowHeight + 'px';
            botShadow.style.height = Math.abs(currentScroll - 1) * shadowHeight + 'px';
        } else {
            topShadow.style.opacity = 0;
            botShadow.style.opacity = 0;
        }
    }

    return (
        <>
            <ShadowWrapper>
                <ShadowTop ref={topRef} />
                <ShadowBottom ref={botRef} />
            </ShadowWrapper>
            <PaddedWrapper
                ref={bodyRef}
                onScroll={adjustShadow}
            >
                <ContentWrapper>
                    {children}
                </ContentWrapper>
            </PaddedWrapper>
        </>
    );
}

export default Content;
